import React from 'react';

export default function NotFound() {
  return (
    <div className="container">
      <h1>Doh! 404!</h1>
      <p>Looks like the page you are looking for is missing!</p>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/containers/NotFound/NotFound.js